import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { formatCurrency } from '@roc/ui/utils';

const useStyles = makeStyles((theme: Theme) => ({
  titleCell: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    fontWeight: 'bold',
  },
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

const CURRENCY_FIELDS = new Set(['annualFeeAmount', 'feeAmountByFrequency', 'portalAnnualFeeAmount']);

interface FieldRow {
  label: string;
  documentKey: string;
  portalKey?: string;
}

const FIELD_ROWS: FieldRow[] = [
  { label: 'Property Address', documentKey: 'propertyAddress', portalKey: 'portalPropertyAddress' },
  { label: 'Annual HOA Fee Amount', documentKey: 'annualFeeAmount', portalKey: 'portalAnnualFeeAmount' },
  { label: 'Fee Frequency', documentKey: 'feeFrequency' },
  { label: 'Fee Amount by Frequency', documentKey: 'feeAmountByFrequency' },
];

const formatValue = (key: string, value: any) => {
  if (value === null || value === undefined || value === '') return '—';
  if (CURRENCY_FIELDS.has(key)) return formatCurrency(Number(value));
  return String(value);
};

export interface HoaReviewTableProps {
  data: Record<string, any>;
}

export const HoaReviewTable = ({ data }: HoaReviewTableProps) => {
  const classes = useStyles();

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell className={classes.titleCell}>Field</TableCell>
          <TableCell className={classes.titleCell}>Portal</TableCell>
          <TableCell className={classes.titleCell}>Document</TableCell>
        </TableRow>
        {FIELD_ROWS.map((row, index) => (
          <TableRow key={row.documentKey} className={index === FIELD_ROWS.length - 1 ? classes.lastRow : ''}>
            <TableCell className={classes.labelCell}>{row.label}</TableCell>
            <TableCell className={classes.valueCell}>
              {row.portalKey ? formatValue(row.portalKey, data?.[row.portalKey]) : '—'}
            </TableCell>
            <TableCell className={classes.valueCell}>
              {formatValue(row.documentKey, data?.[row.documentKey])}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
